import { cn } from '@/lib/utils';

interface StepDotsProps {
  total: number;
  current: number;
}

export function StepDots({ total, current }: StepDotsProps) {
  return (
    <div className="flex items-center justify-center gap-2" role="tablist" aria-label="Steg">
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          role="tab"
          aria-selected={i === current}
          aria-label={`Steg ${i + 1}`}
          className={cn(
            'block rounded-full transition-all duration-300',
            i === current
              ? 'w-2 h-2 bg-foreground'
              : 'w-1.5 h-1.5 bg-muted-foreground/30'
          )}
        />
      ))}
    </div>
  );
}
